import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { cn } from '../lib/utils';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Servicios',
    href: '#servicios'
  }, {
    name: 'IA',
    href: '#ia'
  }, {
    name: 'Beneficios',
    href: '#beneficios'
  }, {
    name: 'Resultados',
    href: '#resultados'
  }, {
    name: 'Proceso',
    href: '#proceso'
  }];
  return <header className={cn('fixed top-0 left-0 right-0 z-50 transition-all duration-300', isScrolled ? 'bg-white/90 backdrop-blur-md shadow-glass py-3 border-b-2 border-brand-cyan' : 'bg-white/60 backdrop-blur-sm py-5 border-b border-brand-cyan/40')} data-id="element-174">
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-175">
        <a href="#" className="flex items-center gap-2" data-id="element-176">
          <img src="https://cdn.magicpatterns.com/uploads/xq3A4qTnhBr3i72N1qfHwy/Nicova_Digital_horizontal_logo,_abstract_geometric_N_symbol_on_the_left_in_black_with_turquoise_cyan_accents,_company_name_NICOVA_DIGITAL_on_the_right_in_black_typography,_white_background,_modern_sans-serif_typefac.jpg" alt="Nicova Digital Logo" className="h-10 md:h-12 object-contain" data-id="element-177" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-178">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-slate-600 hover:text-brand-cyan transition-colors" data-id="element-179">
              {link.name}
            </a>)}
          <a href="#contacto" className="bg-brand-cyan text-brand-black px-6 py-2.5 rounded-full text-sm font-bold hover:bg-brand-black hover:text-white transition-colors shadow-glow" data-id="element-180">
            Solicitar Diagnóstico Gratuito
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="lg:hidden text-brand-black p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-181">
          {mobileMenuOpen ? <X size={24} data-id="element-182" /> : <Menu size={24} data-id="element-183" />}
        </button>
      </div>

      {/* Mobile Nav */}
      {mobileMenuOpen && <div className="lg:hidden absolute top-full left-0 right-0 bg-white shadow-card border-t border-slate-100 py-4 px-6 flex flex-col gap-4" data-id="element-184">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-base font-medium text-slate-700 py-2 border-b border-slate-50" onClick={() => setMobileMenuOpen(false)} data-id="element-185">
              {link.name}
            </a>)}
          <a href="#contacto" className="bg-brand-black text-white px-6 py-3 rounded-full text-center font-semibold mt-2" onClick={() => setMobileMenuOpen(false)} data-id="element-186">
            Solicitar Diagnóstico Gratuito
          </a>
        </div>}
    </header>;
}